import { render, staticRenderFns } from "./BetListModal.vue?vue&type=template&id=c60e9564&scoped=true"
import script from "./BetListModal.vue?vue&type=script&lang=js"
export * from "./BetListModal.vue?vue&type=script&lang=js"
import style0 from "./BetListModal.vue?vue&type=style&index=0&id=c60e9564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60e9564",
  null
  
)

export default component.exports